<header class="{{ originNamespace }}-namespace">
  <h1>
    @if (shownComplyTitle) {
      {{ shownComplyTitle }}
    } @else {
      Kyloe {{ appName }}
      @if (originNamespace) {
        <span
          >for <span>{{ originNamespace }}</span></span
        >
      }
    }
  </h1>
  <div>
    @if (showEntityPicker && userLoggedIn) {
      <app-entity-picker (selected)="entitySelected($event)" [embedded]="false" [clearOnSelection]="true"> </app-entity-picker>
    }
  </div>

  <div class="right-container">
    <div class="pendo-header-container"></div>
    <div class="header-extra">
      <ng-content select="[userPicker]"></ng-content>
    </div>
    @if (tenantName) {
      <span class="tenant-name" [matTooltip]="'Logged in with tenant: ' + tenantName" matTooltipShowDelay="500">
        <mat-icon fontIcon="people"></mat-icon>
        {{ tenantName }}
      </span>
    }

    <a
      href="http://www.KyloePartners.com"
      target="_blank"
      class="kyloe-logo-mask white overlay-darker-purple"
      [ngClass]="{ 'overlay-red': originNamespace === 'invenias' }"
      [matTooltip]="'Visit our website'"
      matTooltipShowDelay="500"
      appRipple
    ></a>
  </div>
</header>
